import type { PaywallIntentParams } from './types';

class Content {
	static requestedPaywallIntent: BotPaywallIntentParams | undefined = undefined;
}

type BotPaywallIntentParams = PaywallIntentParams & {
	botId: string;
};

export const useNeedsToShowBotPaywall = () => {
	const setNeedsToShowBotPaywall = (
		state: BotPaywallIntentParams | undefined
	) => {
		Content.requestedPaywallIntent = state;
	};

	return {
		requestedPaywallBotData: Content.requestedPaywallIntent,
		setNeedsToShowBotPaywall,
	};
};
